module.exports = __webpack_public_path__ + "static/media/gerb-5.9db2e647.png";